export default __webpack_public_path__ + "static/media/checkmark.3b9ec414.svg";